// extracted by mini-css-extract-plugin
module.exports = {"partBox":"list_partBox__3_uFi","row":"list_row__3u7XZ","partName":"list_partName__3Nepq","partNumber":"list_partNumber__3EM9o","linePrice":"list_linePrice__eSodz"};